<script setup>
</script>
<template>
  <div class="page-container new_article_design">
    <section class="blog-article-section">
      <article class="blog-article">
        <div class="container">
          <div class="single-article-wrapper">
            <div class="blog-post-date">January 22, 2025</div>
            <h1 class="article-title">
              January updates: Trade from charts, Watchlist tags and more
            </h1>
            <div class="article-cat">
              Blog |
              <a
                href="/market-talk/category/newsletters/morning-update/"
                rel="category tag"
                >Morning Update</a
              >
            </div>
            <div class="single-article-featured-img">
              <img
                width="937"
                height="534"
                src="https://upstox.com/app/uploads/2025/01/image-2.png"
                class="secondary-thumbnail"
                alt=""
                loading="lazy"
                srcset="
                  https://upstox.com/app/uploads/2025/01/image-2.png         937w,
                  https://upstox.com/app/uploads/2025/01/image-2-300x171.png 300w,
                  https://upstox.com/app/uploads/2025/01/image-2-768x438.png 768w,
                  https://upstox.com/app/uploads/2025/01/image-2-50x28.png    50w
                "
                sizes="(max-width: 937px) 100vw, 937px"
              />
            </div>
            <div class="single-article-content">
              <p>
                <span style="font-weight: 400">New Year, Newer Us! 🎉🚀</span>
              </p>
              <p>
                <span style="font-weight: 400"
                  >We’re starting off 2025 with exciting updates to level up
                  your trading and investing journey. Ready to unlock fresh
                  possibilities and make this your best financial year yet?
                  Let’s go! 💪✨</span
                >
              </p>
              <p>
                <span style="font-weight: 400">💜 </span
                ><span style="text-decoration: underline"
                  ><strong
                    >Major updates on ‘Upstox Pro for traders’</strong
                  ></span
                ><b><br /> </b><b><br /> </b
                ><strong
                  >🚀 Trade, manage &amp; execute positions from charts</strong
                ><b><br /> </b>You can now place instant orders directly from
                the charts and view your open positions along with P&amp;L. You
                can also close positions from the charts and modify your limit
                orders by simply dragging the order line.
              </p>
              <p>
                <span style="font-weight: 400"
                  ><img
                    loading="lazy"
                    class="alignnone wp-image-50014 size-full"
                    src="https://upstox.com/app/uploads/2025/01/Trade-from-Chart_v2.gif"
                    alt=""
                    width="500"
                    height="354"
                /></span>
              </p>
              <p>
                <span style="font-weight: 400"><br /> </span><b>▶️ </b
                ><strong>Corporate Actions Updates</strong>
              </p>
              <p>
                <span style="font-weight: 400"
                  >Receive updates on your holdings whenever a stock announces
                  corporate actions like splits, dividends, or bonuses,
                  including a summary of how it impacts your holdings</span
                >
              </p>
              <p>
                <span style="font-weight: 400"
                  ><img
                    loading="lazy"
                    class="alignnone wp-image-50015 size-full"
                    src="https://upstox.com/app/uploads/2025/01/Corporate-actions_v1.gif"
                    alt=""
                    width="500"
                    height="567" /></span
                ><span style="font-weight: 400"><br /> </span
                ><span style="font-weight: 400"
                  ><br />
                  🚀 </span
                ><strong>MCX Commodities Option Chain on Web Pro</strong
                ><b><br /> </b
                ><span style="font-weight: 400"
                  >Now access the Option Chain for Crude Oil, Natural Gas, Gold,
                  and Silver directly from the Options tab.</span
                >
              </p>
              <p>
                <img
                  loading="lazy"
                  class="alignnone wp-image-50016 size-full"
                  src="https://upstox.com/app/uploads/2025/01/MCX_v1.gif"
                  alt=""
                  width="600"
                  height="425"
                />
              </p>
              <p>&nbsp;</p>
              <p>
                <span style="font-weight: 400">💜 </span
                ><span style="text-decoration: underline"
                  ><strong
                    >Minor updates on ‘Upstox Pro for traders’</strong
                  ></span
                >
              </p>
              <p>
                <b>▶️ </b><strong>Square-off Timer</strong
                ><span style="font-weight: 400"
                  ><strong>:</strong> A visual indicator highlights open
                  intraday positions after 3 PM, helping you close them manually
                  and avoid additional auto square-off charges</span
                >
              </p>
              <p>
                <b>▶️ </b><strong>New Pinned Indices header Design</strong
                ><span style="font-weight: 400"
                  ><strong>:</strong> The redesigned header provides a more
                  intuitive layout, making it easier to track indices and
                  navigate smoothly</span
                >
              </p>
              <p>
                <b>▶️ </b><strong>Holdings in Watchlist</strong
                ><span style="font-weight: 400"
                  ><strong>:</strong> Quickly identify your holdings directly in
                  the watchlist, along with live price changes and percentage
                  movements for instant tracking</span
                >
              </p>
              <p>
                <b>▶️ </b><strong>ATM, ITM, OTM tags on the Watchlist</strong
                ><span style="font-weight: 400"
                  ><strong>:</strong> Options traders can now see "At the Money"
                  (ATM), "In the Money" (ITM), and "Out of the Money" (OTM) tags
                  on Options strikes in their watchlist. This will help in
                  strike selection based on market movement and liquidity</span
                >
              </p>
              <p>
                <b>▶️ </b
                ><strong
                  >Sensex Index added in OI Analysis tab under Discover</strong
                ><span style="font-weight: 400"
                  ><strong>:</strong> Access detailed OI (Open Interest), Change
                  in OI, PCR (Put Call Ratio), and Max Pain data for SENSEX
                  weekly options directly under the OI Analysis tab, helping you
                  to make data-driven trades</span
                >
              </p>
              <p>
                <b>▶️ </b
                ><strong
                  >Download CSV for Holdings, Orders, Positions &amp;
                  Watchlist</strong
                ><span style="font-weight: 400"
                  ><strong>:</strong> Export your order book, positions,
                  holdings, and watchlist to a CSV file for custom analysis in
                  Excel. This enables deeper insights into your trading
                  activity</span
                >
              </p>
              <p>
                <b>▶️ </b><strong>Colour-coded LTP</strong
                ><span style="font-weight: 400"
                  ><strong>:</strong> Live prices (LTP) now change colour based
                  on the previous day’s close, giving you a clear visual of
                  rising or falling trends in the market</span
                >
              </p>
              <p>&nbsp;</p>
              <p>
                <span style="font-weight: 400">💜 </span
                ><strong>Major Updates on ‘Upstox Wealth’</strong>
              </p>
              <p>
                <strong>🚀 Step Up SIP</strong><b><br /> </b
                ><span style="font-weight: 400"
                  >A feature that lets you gradually increase your SIP
                  contributions as your income grows. It helps you build wealth
                  faster, stay aligned with your financial goals, and adjust
                  your investments seamlessly over time</span
                >
              </p>
              <p>
                <img
                  loading="lazy"
                  class="alignnone wp-image-50013 size-full"
                  src="https://upstox.com/app/uploads/2025/01/Invest.gif"
                  alt=""
                  width="500"
                  height="567"
                />
              </p>
              <p>
                <strong>🚀 Modify-SIP</strong><b><br /> </b
                ><span style="font-weight: 400"
                  >Adjusting your SIP amount or date used to mean canceling it
                  and setting up a new one. With Modify-SIP, you can easily
                  update these details directly. We’ll take care of the backend
                  process, making it seamless and hassle-free for you.</span
                >
              </p>
              <p>&nbsp;</p>
              <p>
                <span style="font-weight: 400"
                  >That’s it for now, folks! 🎉 These new features are here to
                  start off your 2025 trading and investing journey. Love them?
                  Drop us a review on the Play Store or App Store—it’ll make our
                  day! 🚀</span
                >
              </p>
              <p>&nbsp;</p>
              <p>
                <span style="font-weight: 400">👉</span
                ><strong>If you’re using old Upstox app (blue):</strong>
                <span style="font-weight: 400"
                  >The new features are only available on the new Upstox app.
                  Once you download the new app, login with your registered
                  mobile number → Go to ‘Accounts’ tab at the bottom of the
                  screen →Switch the toggle button to ‘Upstox Pro’ from the top
                  of the screen.</span
                ><span style="font-weight: 400"><br /> </span
                ><a
                  href="https://play.google.com/store/apps/details?id=com.jobvim.expensetoday&pcampaignid=web_share"
                  target="_blank"
                  ><span style="font-weight: 400">Download new Upstox</span></a
                >
              </p>
              <p>
                <strong
                  >👉 If you’re already using new Upstox app (purple):</strong
                ><span style="font-weight: 400">
                  Directly go to ‘Accounts’ tab at the bottom of the screen.
                  Switch the toggle button to ‘Upstox Pro’ from the top of the
                  screen.</span
                ><span style="font-weight: 400"><br /> </span
                ><a
                  href="https://play.google.com/store/apps/details?id=com.jobvim.expensetoday&pcampaignid=web_share"
                  target="_blank"
                  ><span style="font-weight: 400">Take me to the app</span></a
                >
              </p>
            </div>
          </div>
        </div>
        <div class="download-App">
          <a
            href="https://bkafq.app.link/CjT31xOUosb"
            class="downApp-item"
            target="_blank"
          >
            <div class="app-icon">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/blog/apple-icon.png"
                alt="apple-icon"
              />
            </div>
            <div class="content-fold">
              <div class="text-logo">
                <span>Download</span>
                <div class="logoImg">
                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/blog/upstox-logo-primary.svg"
                    alt="logo"
                  />
                </div>
              </div>
              <h3>iOS App</h3>
            </div>
          </a>
          <a
            href="https://bkafq.app.link/CjT31xOUosb"
            class="downApp-item"
            target="_blank"
          >
            <div class="app-icon">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/blog/play-store-icon.png"
                alt="play-store"
              />
            </div>
            <div class="content-fold">
              <div class="text-logo">
                <span>Download</span>
                <div class="logoImg">
                  <img
                    src="https://upstox.com/app/themes/upstox/dist/img/blog/upstox-logo-primary.svg"
                    alt="logo"
                  />
                </div>
              </div>
              <h3>Android App</h3>
            </div>
          </a>
        </div>
      </article>
    </section>
  </div>
</template>
<style scoped>
</style>
